import type { Direction, Locale } from '../types';
import { ar, type ChromeStrings } from './ar';
import { en } from './en';

const DICTIONARIES: Record<Locale, ChromeStrings> = { ar, en };

export const SUPPORTED_LOCALES: Locale[] = ['ar', 'en'];

export function isLocale(value: string): value is Locale {
  return (SUPPORTED_LOCALES as string[]).includes(value);
}

export function directionFor(locale: Locale): Direction {
  return locale === 'ar' ? 'rtl' : 'ltr';
}

/** Returns the chrome string bundle for a locale. */
export function chrome(locale: Locale): ChromeStrings {
  return DICTIONARIES[locale];
}

/** Intl-aware timestamp for the "updated" chip. */
export function formatTimestamp(locale: Locale, date = new Date()): string {
  return new Intl.DateTimeFormat(locale === 'ar' ? 'ar-EG' : 'en-GB', {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(date);
}

/** Formats a data-file refresh date (falls back to today when absent). */
export function formatDataDate(locale: Locale, iso?: string): string {
  const date = iso ? new Date(iso) : new Date();
  return new Intl.DateTimeFormat(locale === 'ar' ? 'ar-EG' : 'en-GB', {
    dateStyle: 'long',
  }).format(date);
}
